import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'
import { createSlug } from '@/utils/url'

/**
 * Profile service class containing all methods to retrieve profiles
 */
class ProfileService {
  static getProfiles(limit = 10, page = 1, filter = '') {
    return ApiHelper.fetch(
      `${API.URL + API.PROFILES}?pageSize=${limit}&page=${page}&filter=${filter}`
    )
  }

  static getProfile(email) {
    return ApiHelper.fetch(`${API.URL + API.PROFILES}/${email}`)
  }

  static getProfileById(id, pinCode) {
    let profileUrl = `${API.URL + API.USER}/profile/${id}`

    if (pinCode) {
      profileUrl += `/${pinCode}`
    }

    return ApiHelper.fetch(profileUrl)
  }

  static updateProfile(profile) {
    return ApiHelper.fetch(`${API.URL + API.PROFILES}`, {
      method: 'PUT',
      body: JSON.stringify({
        profile: profile
      })
    })
  }

  static deleteProfile(email) {
    return ApiHelper.fetch(`${API.URL + API.PROFILES}/${email}`, {
      method: 'DELETE'
    })
  }

  static exportProfiles() {
    return ApiHelper.fetch(`${API.URL}/export`)
  }

  static getProfileUrl(profile) {
    if (profile == undefined) {
      return undefined
    }

    const sluggedBits = createSlug(`${profile.firstName}-${profile.lastName}-${profile._id}`)
    return `/user-profile/${sluggedBits}`.toLowerCase()
  }
}

export default ProfileService
